export default "__VITE_ASSET__7a407aa0__"